<template>
  <div class="contract-list">
    <div>
      <el-row class="filter-wrap" :gutter="20">
        <el-col :span="5">
          <el-input v-model="form.code" size="small" placeholder="发票编号" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model="form.applicantName" size="small" placeholder="开票申请人" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model="form.contractName" size="small" placeholder="合同名称/编号" @keyup.enter.native="onSearch"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
        </el-col>

        <el-col :span="4">
          <el-button type="default" size="small" @click="onReset">重置</el-button>
          <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px" :gutter="20">
        <el-col :span="5" class="input-group">
          <el-select v-model="form.showStatusList" multiple size="small" placeholder="开票状态" class="w-100">
            <el-option v-for="(item, index) in getStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" class="input-group">
          <el-input v-model="form.minInvoiceMoney" size="small" placeholder="最小开票金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
          <span>~</span>
          <el-input v-model="form.maxInvoiceMoney" size="small" placeholder="最大开票金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-col>
        <el-col :span="8" class="input-group">
          <el-date-picker v-model="form.startTime" type="date" placeholder="最早申请时间" size="small" value-format="yyyy-MM-dd 00:00:00" :picker-options="pickerMin">
          </el-date-picker>
          <span>~</span>
          <el-date-picker v-model="form.endTime" type="date" placeholder="最近申请时间" size="small" value-format="yyyy-MM-dd 23:59:59" :picker-options="pickerMax">
          </el-date-picker>
        </el-col>
      </el-row>
    </div>

    <div class="table-wrap">
      <el-row class="table-count-wrap" :gutter="20">
        <el-col :span="10">
          <p class="table-count">
            <span>开票总数：{{ page.total }}条</span>
          </p>
        </el-col>
      </el-row>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="发票编号" prop="code" align="center"></el-table-column>
        <el-table-column label="开票申请人" prop="applicantName" align="center"></el-table-column>
        <el-table-column label="开票申请时间" prop="createTime" align="center" width="130"></el-table-column>
        <el-table-column label="合同名称" prop="contractName" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.contractName }}</p>
            <p>{{ scope.row.contractCode }}</p>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
        <el-table-column label="开票金额" prop="invoiceMoney" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.invoiceMoney) }}
          </template>
        </el-table-column>
        <el-table-column label="开票类型" prop="invoiceType" align="center">
          <template slot-scope="scope">
            {{ billingConfig.getAppointed("status", scope.row.invoiceType) }}
          </template>
        </el-table-column>
        <el-table-column label="开票明细" prop="invoiceDetail" align="center">
          <template slot-scope="scope">
            {{ billingConfig.getAppointed("invoice_status", scope.row.invoiceDetail) }}
          </template>
        </el-table-column>

        <el-table-column label="发票照片" prop="photoName" align="center" >
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.invoicePhotoList"></filePreview>
          </template>
        </el-table-column>
        <el-table-column label="开票状态" prop="status" align="center">
          <template slot-scope="scope">
            <div v-if="
                scope.row.showStatus == 15
              ">
              审批通过
              <div class="color_danger">(未上传发票)</div>
            </div>
            <div v-else-if="
                scope.row.showStatus == 16
              ">
              审批通过
              <div class="color_success">(已上传发票)</div>
            </div>
            <template v-else>
              <div v-for="(item,index) in getStatusList" :key="index">
                {{scope.row.showStatus == item.value ?item.label:''}}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toShow(scope.row.id)">查看详情</el-button>
            <el-button v-if="scope.row.status == contractConfig.Status.AssessFail" type="text" size="small" @click="onShowReason('原因', scope.row.reason)">原因</el-button>
            <el-button v-if="scope.row.status == contractConfig.Status.Voided" type="text" size="small" @click="onShowReason('作废原因', scope.row.reason)" style="margin-left: 0">作废原因</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <!-- 详情表单 -->

    <el-dialog title="查看详情" :visible.sync="Detaildialog">
      <el-form :model="detailForm" disabled>
        <el-form-item label="客户名称" prop="customerName" class="block-form-item w-32">
          <el-input v-model="detailForm.customerName"></el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="companyPhone" class="block-form-item w-32">
          <el-input v-model="detailForm.companyPhone" dis></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddress" class="block-form-item w-32">
          <el-input v-model="detailForm.companyAddress"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxpayerId" class="block-form-item w-32">
          <el-input v-model="detailForm.taxpayerId"></el-input>
        </el-form-item>
        <el-form-item label="客户开户行" prop="customerBank" class="block-form-item w-32">
          <el-input v-model="detailForm.customerBank"></el-input>
        </el-form-item>
        <el-form-item label="客户银行账号" prop="customerBankAccount" class="block-form-item w-32">
          <el-input v-model="detailForm.customerBankAccount"></el-input>
        </el-form-item>
        <el-form-item label="开票金额" prop="invoiceMoney" class="block-form-item w-32">
          <el-input v-model="detailForm.invoiceMoney"></el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoiceType" class="block-form-item w-32">
          <el-select v-model="detailForm.invoiceType" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable" 
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票明细" prop="invoiceDetail" class="block-form-item w-32">
          <el-select v-model="detailForm.invoiceDetail" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceDetail')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable"
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票主体" prop="finAccountName" class="block-form-item w-32">
          <el-input v-model="detailForm.finAccountName"></el-input>
        </el-form-item>
        <el-form-item label="开票备注" prop="remark" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="detailForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <h4>其他信息</h4>
      <div class="block-form-item w-32">开票申请人：{{detailForm.applicantName}}</div>
      <div class="block-form-item w-32">开票申请时间：{{detailForm.applyTime}}</div>
      <div class="block-form-item w-32">快递单号：{{detailForm.expressNumber}}</div>
      <div class="invoiceImg">
          <div>发票照片:</div>
          <div style="margin-left:5px;">
            <div v-for="(item,index) in detailForm.invoicePhotoList" :key="index" style="padding-bottom:5px;">
              <a class="link" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.path">{{ item.name }}</a>
            </div>
          </div>
        </div>
      <h4 class="mb-10">审批信息</h4>
      <approve-list :approveObj="approveObj" :auditStatus="auditStatus" class="mb-10"></approve-list>
      <div class="mb-10">审批备注：{{assessForm.auditRemark}}</div>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/invoice";
import { billingConfig,billingShow } from "@/const/config/billing";
import approveList from "@/components/common/approveInvoiceMember";
import { invoiceList, invoiceDetail } from "@/api/business/contract";
export default {
  components: {
    approveList,
  },
  data() {
    var that = this;
    return {
      billingShow,
      Detaildialog: false,
      contractConfig: contractConfig,
      billingConfig,
      pickerMin: {
        disabledDate(time) {
          if (validate.checkNull(that.form.endTime)) return false;
          return time.getTime() > new Date(that.form.endTime).getTime();
        },
      },
      pickerMax: {
        disabledDate(time) {
          if (validate.checkNull(that.form.startTime)) return false;
          return time.getTime() < new Date(that.form.startTime).getTime();
        },
      },
      //调整监测时间规则
      timeOptionRange: "",
      jobRangePicker: {
        onPick: (time) => {
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          let t = new Date(dateFormat(new Date()).split(" ")[0] + " 00:00:00");
          let timeOptionRange = this.timeOptionRange;
          let secondNum = 60 * 60 * 24 * 6 * 1000;
          if (timeOptionRange) {
            return (
              time.getTime() <= t.getTime() ||
              time.getTime() < timeOptionRange.getTime() - secondNum ||
              time.getTime() > timeOptionRange.getTime() + secondNum
            );
          }
          return time.getTime() <= t.getTime();
        },
      },
      form: {
        code: "", //发票编号
        applicantName: "", //开票申请人
        contractName: "", //合同名称
        customerName: "", //客户名称
        showStatusList: "", //开票状态
        minInvoiceMoney: "", //最小金额
        maxInvoiceMoney: "", //最大金额
        startTime: "", //起始时间
        endTime: "", //结束时间
      },
      detailForm: {
        customerName: "", //名称
        companyPhone: "", //电话
        companyAddress: "", //公司地址
        taxpayerId: "", //纳税人识别号
        customerBank: "", //客户开户行
        customerBankAccount: "", //客户银行账户
        kaipiaojine: "", //开票金额
        invoiceType: "", //发票类型
        invoiceDetail: "", //开票明细
        remark: "", //合同备注
      },
      assessForm: {
        auditRemark: "",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      approveObj: {},
      auditStatus: null,
      getStatusList:[
        { value: 5,label: '4级审批中'},
        { value: 6,label: '4级审批不通过'},
        { value: 7,label: '3级审批中'},
        { value: 8,label: '3级审批不通过'},
        { value: 9,label: '2级审批中'},
        { value: 10,label: '2级审批不通过'},
        { value: 11,label: '财务审批中'},
        { value: 12,label: '财务审批不通过'},
        { value: 13,label: '出纳审批中'},
        { value: 14,label: '出纳审批不通过'},
        { value: 15,label: '审批通过-未上传发票'},
        { value: 16,label: '审批通过-已上传发票'},
        { value: 17,label: '已作废'},
      ]
    };
  },
  mounted() {
    // console.log(this.$route.query.id);
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        code: "",
        applicantName: "",
        contractName: "",
        customerName: "",
        statusList: "",
        minInvoiceMoney: "",
        maxInvoiceMoney: "",
        startTime: "",
        endTime: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if (this.form.minInvoiceMoney && this.form.maxInvoiceMoney) {
        if (
          parseInt(this.form.minInvoiceMoney) >
          parseInt(this.form.maxInvoiceMoney)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      console.log("", queryObj);
      this.tableLoading = true;
      invoiceList(queryObj)
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      this.Detaildialog = true;
      invoiceDetail({ id }).then((res) => {
        let result = res.data;
        console.log("详情=====", result);
        let obj = {
          exStaff4Name: result.exStaff4Name,
          staff4NameList: result.staff4NameList,
          exStaff3Name: result.exStaff3Name,
          staff3NameList: result.staff3NameList,
          exStaff2Name: result.exStaff2Name,
          staff2NameList: result.staff2NameList,
          exTreasurerName: result.exTreasurerName,
          treasurerNameList: result.treasurerNameList,
          exCashierName: result.exCashierName,
          cashierNameList: result.cashierNameList,
        };
        this.approveObj = obj;
        this.auditStatus = result.auditStatus;
        this.assessForm.auditRemark = result.auditRemark;
        if (res.code == 1) {
          this.detailForm = res.data;
        }
      });
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "";
      this.$alert(reason, text, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
};
</script>

<style lang="scss" scoped>
.invoiceImg{
  display: flex;
  margin-top:-35px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  span {
    margin-right: 20px;
  }
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    min-height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
// 弹出框body
/deep/.el-dialog__body {
  padding-top: 0 !important;
  .mb-10 {
    margin-bottom: 10px;
  }
}
</style>